import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';

interface TaskState {
  taskIds: string[];
}

const initialState: TaskState = {
  taskIds: [],
};

const taskSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    setTaskIds: (state, action: PayloadAction<string[]>) => {
      state.taskIds = action.payload;
    },
    clearTaskIds: (state) => {
      state.taskIds = [];
    },
    addTaskId: (state, action: PayloadAction<string>) => {
      if (!state.taskIds.includes(action.payload)) {
        state.taskIds.push(action.payload);
      }
    },
    removeTaskId: (state, action: PayloadAction<string>) => {
      state.taskIds = state.taskIds.filter((id) => id !== action.payload);
    },
  },
});

export const { setTaskIds, clearTaskIds, addTaskId, removeTaskId } = taskSlice.actions;
export default taskSlice.reducer;

// Selector
export const selectTaskIds = (state: RootState) => state.tasks.taskIds;
